import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Body from 'syf-component-library/ui/typography/Body'
import query from 'syf-component-library/const/mediaQueries'
import { colors } from 'theme'
import {
  fontSizes,
  fontWeights,
  spacing
} from 'syf-component-library/defaultTheme'

const BRAND_REFRESH_DEFAULT_CONTENT_COLOR = 'var(--syfds-color-content-default)'
const BRAND_REFRESH_BUTTON_BACKGROUND =
  'var(--syfds-button-primary-color-background-brand-default)'
const BRAND_REFRESH_BUTTON_CONTENT_COLOR =
  'var(--syfds-button-primary-color-content-brand-default)'

export const NotificationCardWrapper = styled.div`
  background: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? 'var(--syfds-color-background-default)'
      : colors.cyanBlue};
  border: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? 'var(--syfds-border-width-sm) solid var(--syfds-color-border-subtle-default)'
      : `2px solid ${colors.pewterBlue}`};
  border-radius: ${spacing.small}px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: ${spacing.medium}px;

  @media (${query.lessThanSmall}) {
    align-content: flex-end;
    border-bottom-right-radius: 0;
    border-right: 0;
    border-top-right-radius: 0;
    margin-top: ${spacing.base}px;
  }
`

export const NotificationCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${spacing.base}px ${spacing.large}px;
  cursor: pointer;
`

export const NotificationCardBody = styled.div`
  font-weight: ${fontWeights.regular};
  line-height: ${spacing.large}px;
  color: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? BRAND_REFRESH_DEFAULT_CONTENT_COLOR
      : colors.white};
`

export const NotificationDescription = styled.div`
  margin: 0 ${spacing.large}px ${spacing.base}px;
`

export const AccountList = styled.ul`
  list-style: disc;
  padding: 0;
`

export const AccountName = styled.li`
  margin-left: ${spacing.large}px;
`

export const RoundCircle = styled.div`
  align-items: center;
  align-self: flex-start;
  background: ${colors.yellow};
  border-radius: 50%;
  display: flex;
  flex-shrink: 0;
  height: ${spacing.xxlarge}px;
  justify-content: center;
  text-align: center;
  width: ${spacing.xxlarge}px;
`

export const NotificationExclamation = styled(Body)`
  color: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? BRAND_REFRESH_DEFAULT_CONTENT_COLOR
      : colors.cyanBlue};
  font-size: ${fontSizes.medium}px;
  line-height: 28px;
`
export const NotificationTitle = styled(Body)`
  color: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? BRAND_REFRESH_DEFAULT_CONTENT_COLOR
      : colors.white};
  margin: 0 ${spacing.base}px;
  text-align: left;
  width: 100%;
`
export const CollapseButton = styled.button`
  align-items: center;
  background: none;
  border: 0;
  cursor: pointer;
  display: flex;
`

export const CollapseIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? BRAND_REFRESH_DEFAULT_CONTENT_COLOR
      : colors.white};
  height: ${spacing.large}px;
  width: ${spacing.large}px;
`

export const NotificationActionLink = styled.button`
  align-items: center;
  background: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? BRAND_REFRESH_BUTTON_BACKGROUND
      : colors.darkSlateGray};
  border: 0;
  border-bottom-left-radius: ${spacing.small}px;
  border-bottom-right-radius: ${spacing.small}px;
  color: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? BRAND_REFRESH_BUTTON_CONTENT_COLOR
      : colors.yellow};
  display: flex;
  min-height: 58px;
  padding: 16px;
  width: 100%;

  & :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

export const NotificationActionText = styled.span`
  font-weight: ${fontWeights.bold};
  line-height: ${spacing.large}px;
  margin-left: auto;
  text-align: right;
`

export const RightAngleIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) =>
    theme?.brandRefreshPhase >= 1
      ? BRAND_REFRESH_BUTTON_CONTENT_COLOR
      : colors.yellow};
  padding-left: 5px;
`
